<script setup lang="ts">
const { locale }  = useI18n()
const route = useRoute()
const runtimeConfig = useRuntimeConfig()

export interface EducationData extends payloadData {
  docs: Education[]
}

const previewSecret = runtimeConfig?.previewSecret || runtimeConfig?.public?.previewSecret
const isPreview = computed(() => route?.query?.previewSecret === previewSecret)

const { data, error, status } = await useAsyncData<Education>(
  () => `education-${route.params.slug}-${locale.value}-${isPreview.value}`,
  () => {
    return $fetch<Education>('/api/payload-gql', {
      method: 'POST',
      body: {
        query: SingleEducationQuery,
        isPreview: isPreview.value,
        variables: {
          slug: { equals: route.params.slug },
          isPreview: isPreview.value,
          status: isPreview.value ? 'draft' : 'published',
          locale: locale.value,
        },
      },
    })
  },
  { transform: (data: EducationData) => transformPayloadData<EducationData>(data) as Education }
)

if (error.value) {
  throw createError({ statusCode: 500, statusMessage: 'Error fetching page' })
}

if (status.value === 'success' && !data.value && !isPreview.value) {
  throw createError({ statusCode: 404, statusMessage: 'Page not found' })
}

// Head
useHead({
  title: computed(() => data.value?.title),
})

useSeoMeta({
  title: computed(() => `${data.value?.title} – Manifesta 16 Ruhr`),
  ogTitle: computed(() => `${data.value?.title} – Manifesta 16 Ruhr`),
})
</script>

<template>
  <div>
    <layout-page-modal
      :parent-route="{ name: 'education' }"
    >
      <pages-education-slug
        :data="data"
      />
    </layout-page-modal>
  </div>
</template>
